  var _piwikTrackerLoaded = false;
  var _initializeTracker = null;
  
  /**
  * An object to manage Piwik as a PiwikManager plugin
  * @constructs PiwikTracker
  * @memberof Class
  * @author Alessandro Cipolletti
  */
  function PiwikTracker(serverConfNode) {
	
	this.account = serverConfNode.id;
	this.accountUrl = serverConfNode.url.replace("piwik.php", "").replace("piwik.js", "");
	this.loadTracker();
	
}

PiwikTracker.prototype.isLoaded = function () {
	return _piwikTrackerLoaded;
}

/**
* Load the piwik tracker
* @author Alessandro Cipolletti, Bruno Sabot
*/
PiwikTracker.prototype.loadTracker = function () {
	
	if (_piwikTrackerLoaded) {
		return;
	}
	
	_initializeTracker = new Promise(function (resolve) {
		window.piwikAsyncInit = resolve;
	});
	
	// Inclusion du script Piwik
	var g = document.createElement("script");
	var s = document.getElementsByTagName("script")[0];
	g.type = "text/javascript";
	g.async = true;
	g.defer = true;
	g.onload = function () {
		_piwikTrackerLoaded = true;
	};
	g.src = this.accountUrl + "piwik.js";
	s.parentNode.insertBefore(g, s);
	
	
};

/**
* Track a page view
* @param  {String} page  The page code name viewed
* @param  {String} hash  The hash of the page viewed
* @param  {String} title The page title
* @author Alessandro Cipolletti, Bruno Sabot
*/
PiwikTracker.prototype.trackPage = function (page, url, title) {
	
	// Need the Piwik tracker to be ready
	_initializeTracker.then(function () {
		
		// Track
		var piwikTracker = Piwik.getTracker(this.accountUrl + "piwik.php", this.account);
		piwikTracker.setCustomUrl(url);
		piwikTracker.setDocumentTitle(title);
		piwikTracker.trackPageView();
		
	}.bind(this));
	
};

/**
* Track a page event
* @param  {String}  category The event category
* @param  {String}  action   The event name
* @param  {String}  label    The action label
* @param  {integer} value    A complementary figure
* @author Alessandro Cipolletti, Bruno Sabot
*/
PiwikTracker.prototype.trackEvent = function (category, action, label, value) {
	
	// Need the Piwik tracker to be ready
	_initializeTracker.then(function () {
		
		var piwikTracker = Piwik.getTracker(this.accountUrl + "piwik.php", this.account);
		if (value) {
			piwikTracker.trackEvent(action, label);
		} else {
			piwikTracker.trackEvent(action, label, value);
		}
		
	}.bind(this));
	
};

module.exports = PiwikTracker;



//////////////////
// WEBPACK FOOTER
// ./src/utils/statistics/trackers/piwikTracker.js
// module id = 791
// module chunks = 0